export const state = {
  modalViewCareer: false,
  careers: [],
  career: {}
};

export default {};
